import { InventoryTypeEnum } from 'dash-common';
import { BadgeTypes } from 'dash-ui';

export const BADGE_TO_INVENTORY_TYPE_COLOR_MAP: Record<
  InventoryTypeEnum,
  BadgeTypes
> = {
  [InventoryTypeEnum.MODEL]: 'neutral',
  [InventoryTypeEnum.FOR_SALE]: 'active',
};
